import { render, staticRenderFns } from "./MaintanceTable.vue?vue&type=template&id=85814542&scoped=true"
import script from "./MaintanceTable.vue?vue&type=script&lang=js"
export * from "./MaintanceTable.vue?vue&type=script&lang=js"
import style0 from "./MaintanceTable.vue?vue&type=style&index=0&id=85814542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85814542",
  null
  
)

export default component.exports